export default __webpack_public_path__ + "static/media/icon_search_tag_log.aca9721c.svg";